// extracted by mini-css-extract-plugin
export default {"element":"ImageZoomable-module--element--e7650","focus":"ImageZoomable-module--focus--9095a"};